__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "montelpro-news-web";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@montel/montelpro-auth", "5.1.0", () => (Promise.all([__webpack_require__.e(7331), __webpack_require__.e(5140), __webpack_require__.e(6804)]).then(() => (() => (__webpack_require__(6804))))));
			register("@montel/montelpro-shared-components-v2", "3.9.1", () => (Promise.all([__webpack_require__.e(4838), __webpack_require__.e(4386), __webpack_require__.e(5140), __webpack_require__.e(7852), __webpack_require__.e(1439)]).then(() => (() => (__webpack_require__(6782))))));
			register("@montel/signalr-client", "3.0.2", () => (Promise.all([__webpack_require__.e(7331), __webpack_require__.e(5893), __webpack_require__.e(3065)]).then(() => (() => (__webpack_require__(5893))))));
			register("react-dom", "19.2.7", () => (Promise.all([__webpack_require__.e(5140), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "7.18.4", () => (Promise.all([__webpack_require__.e(9143), __webpack_require__.e(118), __webpack_require__.e(5140), __webpack_require__.e(5868)]).then(() => (() => (__webpack_require__(118))))));
			register("react-router", "7.18.4", () => (Promise.all([__webpack_require__.e(9143), __webpack_require__.e(5140), __webpack_require__.e(9949)]).then(() => (() => (__webpack_require__(9949))))));
			register("react-toastify", "11.1.0", () => (Promise.all([__webpack_require__.e(550), __webpack_require__.e(5140)]).then(() => (() => (__webpack_require__(550))))));
			register("react", "19.2.7", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(6540))))));
			register("styled-components", "6.5.0", () => (Promise.all([__webpack_require__.e(882), __webpack_require__.e(5140)]).then(() => (() => (__webpack_require__(882))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};